import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'

import api, { apiActionWithRoute, apiAction } from '../../api'
import { Loading, Error } from  '../../components'

const mapDispatchToProps = (dispatch, { entityName } ) => ({
  getIngredient: entityId => dispatch(apiActionWithRoute(api.getIngredient)(entityId)()),
  fetchFoodKinds: () => dispatch(apiAction(api.getFoodKinds)()),
  fetchRegions: () => dispatch(apiAction(api.getRegions)()),
  fetchLocales: () => dispatch(apiAction(api.getLocales)()),
})

const IngredientLoader = connect(null, mapDispatchToProps)(
  ({ ingredientId, getIngredient, fetchFoodKinds,fetchRegions, fetchLocales, component }) => {
    const isNew = ingredientId === 'new'

    const [loaded, setLoaded] = useState(false)
    const [requirmentsLoaded, setRequirementsLoaded] = useState(false)
    const [hasError, setHasError] = useState(false)
    const [ingredientFetched, setIngredientFetched] = useState(false)

    useEffect(() => {
      (async () => {
        if (!hasError) {
          try {
            if(!requirmentsLoaded) {
              await fetchFoodKinds()
              await fetchRegions()
              await fetchLocales()
              setRequirementsLoaded(true)
            }
            if (!isNew && requirmentsLoaded && !ingredientFetched) {
              setLoaded(false)
              await getIngredient(ingredientId)
              setLoaded(true)
              setIngredientFetched(true)
            }
          } catch(e) {
            setHasError(e)
          }
        }
      })()
    }, [ isNew, ingredientId, requirmentsLoaded, ingredientFetched, hasError ]) //eslint-disable-line react-hooks/exhaustive-deps

    if (hasError) {
      const message = _.get(hasError, 'response.data.error.value') ||
      _.get(hasError, 'response.data') ||
       'Oops, Something went wrong!'

      return <Error error={message}/>
    }


    if (isNew && requirmentsLoaded) {
      return component()
    }
    return loaded ? component() : <Loading />
  },
)

export default IngredientLoader
